module.exports = __webpack_public_path__ + "img/Melissa.53168d7d.png";